import { ds24_retrieve } from "../common/ds24_retrieve";
import { request } from "../browser/request";
import { selectElement } from "../browser/selectElement";
import { setHtml } from "../browser/setHtml";
import { ds24cart_activate_buttons } from "./ds24cart_activate_buttons";
import { ds24cart_updateItemCount } from "./ds24cart_helper";
import { ds24cart_jsonp_args } from "./ds24cart_jsonp_args";
import { ResponseJsonPData } from "./ds24cart_loader";
import { ds24cart_maybe_show_msg } from "./ds24cart_maybe_show_msg";
import { ds24_confirm } from "./ds24_confirm";
import { ds24_checkout_url } from "../common/ds24_checkout_url";

export function ds24_clear_quantity_change_delayed_handler()
{
    if (typeof window.ds24_quantity_change_handler == 'undefined')
    {
        window.ds24_quantity_change_handler = false;
    }
    if (window.ds24_quantity_change_handler) {
        window.clearTimeout( window.ds24_quantity_change_handler );
        window.ds24_quantity_change_handler = 0;
    }
}

export function ds24_on_quantity_change_delayed( raw_input: HTMLInputElement )
{
    ds24_clear_quantity_change_delayed_handler();

    window.ds24_quantity_change_handler = window.setTimeout( function() { ds24_on_quantity_change( raw_input ); }, 4000 );
}

export function ds24_on_quantity_change( raw_input: HTMLInputElement )
{
    ds24_clear_quantity_change_delayed_handler();

    const input: any = raw_input;

    /**
     * Code macht keinen sinn, da ds24_lock am Ende
     * der Wert true gesetzt wird und der Code hier Synchron abgearbeitet wird!
     * Selbst das verwendete ds24_confirm ist synchron.
     */
    // istanbul ignore next
    if (input.ds24_locked) {
        return;
    }

    input.ds24_locked = true;

    const product_id = raw_input.getAttribute('app-product-id') as string;
    const quantity   = parseInt(raw_input.value, 10);

    const is_confirmned = quantity > 0 || window.DS24_INFO_STICKY || ds24_confirm( raw_input );
    if (is_confirmned) {
        ds24cart_set_quantity( parseInt(product_id, 10), quantity );
    }
    else
    {
        raw_input.value = '1';
    }

    input.ds24_locked = false;
}



export function ds24cart_set_quantity( product_id: number, quantity: number )
{

    selectElement<HTMLInputElement>('input.app_cart_quantity', el => el.disabled = true);

    const url = ds24_checkout_url() + '/cart/set/' + product_id + '/' + quantity + '?' + ds24cart_jsonp_args();

    request<ResponseJsonPData>({
        url,
        dataType: 'jsonp',
        success: ds24cart_callback_set
    });

    return false;
}


export function ds24cart_callback_set( result: any )
{
    ds24cart_maybe_show_msg( result );

    const html = ds24_retrieve( result, 'html' );

    selectElement<HTMLDivElement>('div.app_cart_tooltip', tooltip => setHtml(tooltip, html));

    const item_count = ds24_retrieve( result, 'item_count', -1 );

    if (item_count>=0) {
        ds24cart_updateItemCount(item_count);
    }

    ds24cart_activate_buttons( 'div.app_cart_tooltip' );

    selectElement<HTMLInputElement>('input.app_cart_quantity', el => el.disabled = false);

    const htmlInfobar = ds24_retrieve( result, 'infobar_html' );
    if (htmlInfobar) {
        if (htmlInfobar === 'hide') {
            selectElement('#app_cart_added_container', container => container.classList.remove('open'));
        }
        else {
            setHtml(document.querySelector('#app_cart_added_container'), htmlInfobar);
            ds24cart_activate_buttons( '#app_cart_added_container' );
        }
    }

}
